// configs for third party services
export const amplifyExistingResourcesConfig = {
  dev: {
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_oyxJkFFFa",
    aws_user_pools_web_client_id: "64gl76kf3cr1b5n5sg46qlrfo0",
    aws_cognito_identity_pool_id: "us-west-2:2e73c746-2d6f-4b0e-b0f4-e7092b9336fb", // Get this from terraform output after apply
    oauth: {},
    aws_appsync_graphqlEndpoint: "https://yzkvbobf4vcf5hsa47h6sg6mre.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  },
  prod: {
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_1MiSOq1TH",
    aws_user_pools_web_client_id: "4c971t2tel2er4ub4509hlkpvb",
    aws_cognito_identity_pool_id: "us-west-2:f8203f6d-1709-451f-8a72-e779c4c15fd6", // Get this from terraform output after apply
    oauth: {},
    aws_appsync_graphqlEndpoint: "https://6oro2x33cvcw3fkb7rbtsyb2u4.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  },
};

export const thirdPartyConfig = {
  dev: {
    aws_account_id: "050214414362",
    newrelic_account_id: "3148559",
  },
  prod: {
    aws_account_id: "478102786148",
    newrelic_account_id: "2920926",
  },
};
